import { gql, useMutation } from "@apollo/client";
import { useGeneralSoContext } from "src/common/context";
import { WsPayPaymentDetailsDto } from "../types/types";

const GET_WSPAY_PAYMENT_DETAILS_MUTATION = gql(`
 mutation GetWSPayPaymentDetails($id: String!, $paymentType: String!) {
  getWSPayPaymentDetails(id: $id, paymentType: $paymentType) {
    ShopID
    ShoppingCartID
    TotalAmount
    Signature
    PaymentPlan
    CustomerFirstName
    CustomerLastName
    CustomerAddress
    CustomerCity
    CustomerZIP
    CustomerCountry
    CustomerPhone
    CustomerEmail
    PaymentMethod
    Iframe
    IframeResponseTarget
    Version
  }
}
`);

export function useGetWSPayPaymentDetails() {
  const { offerId } = useGeneralSoContext();
  const [mutation, info] = useMutation<{getWSPayPaymentDetails: WsPayPaymentDetailsDto}, { id: string, paymentType: string }>(GET_WSPAY_PAYMENT_DETAILS_MUTATION, {
    fetchPolicy: 'no-cache'
  });
  const getWSPayPaymentDetails = async (paymentType: string) => {
    if (!offerId) {
      throw new Error('Offer ID is required');
    }
    const { data } = await mutation({
      variables: { id: offerId, paymentType },
    });
    return data?.getWSPayPaymentDetails;
  };
  return [getWSPayPaymentDetails, info] as const;
}
